import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss'],
})
export class YoutubePlayerComponent implements OnInit {
  @Input() path_video:string=''
  @Input() title_video?:string=''
  sanitizedUrls: Map<string, SafeResourceUrl> = new Map();
  constructor(private modalController:ModalController,  private domSanitizer: DomSanitizer) { }

  ngOnInit() {}
  closeVideo(){
    this.modalController.dismiss();
   }
   ngOnDestroy() {
 
  }
    getSourceURL(url): SafeResourceUrl {
      let sanitizedUrl = this.sanitizedUrls.get(url);
      let iframe = `<iframe width="100%" height="100%" style="border: none;" src="${url}"  allow="autoplay; encrypted-media;picture-in-picture" allowfullscreen></iframe>`;
      if (!sanitizedUrl) {
        sanitizedUrl = this.domSanitizer.bypassSecurityTrustHtml(iframe)
        this.sanitizedUrls.set(url, sanitizedUrl);
      }
    
      return sanitizedUrl;
    }
}
